export default __webpack_public_path__ + "static/oferta-larsson-nobel-e7fe9a5c0ff098b75492eed71fad4467.pdf";